import { installSharing, capture } from '@/shared/productSharing';
import axios from 'axios';
import Vue from 'vue';
import { captureException } from '@/plugins/error-reporting';
const jwt = require('jsonwebtoken');

let accessToken = localStorage.getItem('access_token') || null;
let boAccessToken = localStorage.getItem('bo_access_token') || null;

function isTokenExpired(token) {
  if (!token) {
    return true;
  }
  try {
    const decodeFunction = Vue.prototype.$jwt.decode;
    const privateKey = Vue.prototype.$privateKey;
    const tokenWithoutBearer = token.replace('Bearer ', '');
    const decoded = decodeFunction(tokenWithoutBearer, privateKey);
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
  } catch (error) {
    return true;
  }
}

installSharing(axios, Vue);

// API request interceptor
axios.interceptors.request.use(function(config) {
  accessToken = localStorage.getItem('access_token');
  boAccessToken = localStorage.getItem('bo_access_token');

  if (accessToken) {
    if (isTokenExpired(accessToken)) {
      console.log('isTokenExpired');
      window.location.href = '/';
    }
    config.headers.Authorization = accessToken;
  }
  if (boAccessToken) {
    config.headers.Authorization = boAccessToken;
  }

  config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

  return config;
}, function(error) {
  captureException(error, { source: 'axios.request' });
  return Promise.reject(error);
});

// API response interceptor
axios.interceptors.response.use(
  function(response) {
    capture(response.config && response.config.url, response.data);
    return Promise.resolve(response.data);
  },
  async function(error) {
    if (axios.isCancel(error)) {
      return Promise.reject(error);
    }

    if (error.response) {
      // Excel downloads receive even JSON errors as Blobs. Decode report errors
      // so callers can show the permission message instead of an empty alert.
      const config = error.config || {};
      if (config.responseType === 'blob' && String(config.url || '').includes('/report/')
          && error.response.data instanceof Blob) {
        try {
          error.response.data = JSON.parse(await error.response.data.text());
        } catch (parseError) {
          error.response.data = { error_message: 'ดาวน์โหลดรายงานไม่สำเร็จ กรุณาลองใหม่' };
        }
      }
      if (error.response.status === 401) {
        if (error.response.data.action != 'authen') {
          window.location.href = '/';
        }  
        return Promise.reject(error.response.data);
      } else if (error.response.status === 400) {
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject(error.response.data);
      }
    } else if (error.request) {
      // Request was made but no response was received
      captureException(error, { source: 'axios.response', type: 'network' });
      return Promise.reject(error);
    } else {
      // Something happened in setting up the request
      captureException(error, { source: 'axios.response', type: 'setup' });
      return Promise.reject(error);
    }
  }
);

Vue.prototype.$axios = axios;
